module.exports = __webpack_public_path__ + "img/htcm_17.376b892e.jpg";